import React from "react";
import {
    ApproveChannelShopEwaybillAuthStatus,
    ChannelShopEwaybillAuthApplyRecord,
    approveChannelShopEwaybillAuth,
    getChannelShopEwaybillAuthRecordList,
} from "./api/setting/ewaybillAccount";
import { Modal, message } from "antd";

function confirm(record: ChannelShopEwaybillAuthApplyRecord) {
    return new Promise<boolean>((resolve) => {
        Modal.confirm({
            title: (
                <div>
                    {record.applicantShopName} 申请使用你微信小店:{record.ewaybillShopSellerUsername}的电子面单
                </div>
            ),
            content: (
                <div>
                    {record.applyChannel === "ES" ? (
                        <>
                            <span className="text-error">
                                同意申请后，{record.applicantShopName}可以使用你的电子面单共享给其他商家或店铺打单
                            </span>
                            ，请注意风险。发货易对此造成的单号损失概不负责
                        </>
                    ) : (
                        <>
                            <span className="text-error">
                                同意申请后，{record.applicantShopName}可以使用你的电子面单打单
                            </span>
                            ，请注意风险。发货易对此造成的单号损失概不负责
                        </>
                    )}
                </div>
            ),
            onOk() {
                resolve(true);
            },
            onCancel() {
                resolve(false);
            },
            cancelText: "拒绝申请",
            okText: "同意申请",
            focusable: { focusTriggerAfterClose: true },
        });
    });
}

/**
 * 微信小店电子面单授权提示
 *
 * 场景是进入后台判断如果当前是微信小店，并且有待审核的微信小店电子面单申请的，就弹框提示处理
 */
export async function showChannelShopApproveEwaybillAuthTips(shopId: number) {
    const list = await getChannelShopEwaybillAuthRecordList(shopId);

    for (let i = 0; i < list.length; i++) {
        const record = list[i];

        if (record.status === ApproveChannelShopEwaybillAuthStatus.APPLIED) {
            try {
                const accept = await confirm(record);

                await approveChannelShopEwaybillAuth({
                    shopId,
                    recordId: record.id,
                    status: accept
                        ? ApproveChannelShopEwaybillAuthStatus.APPROVED
                        : ApproveChannelShopEwaybillAuthStatus.REJECTED,
                });

                if (accept) {
                    message.success("已同意申请");
                } else {
                    message.success("已拒绝申请");
                }
            } catch (error) {}
        }
    }
}
